export enum UserActionTypes {
  API_RESPONSE_SUCCESS = "@@users/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@users/API_RESPONSE_ERROR",

  GET_USER_DATA = "@@users/GET_USER_DATA",
  UPDATE_USER_STATUS = "@@users/UPDATE_USER_STATUS",
  UPDATE_DEVICE_COUNT = "@@users/UPDATE_DEVICE_COUNT",
  UPDATE_DEVICE_COUNT_GLOBALLY = "@@users/UPDATE_DEVICE_COUNT_GLOBALLY",
}
